export const en = {
    'action-add': 'add',
    'action-cancel': 'cancel',
    'error-text': 'The product name can contain Latin letters and the symbols "-" and "_".',
    'product-description-label': 'product description',
    'product-name-label': 'product name'
};
